import * as React from 'react';
import { ResiliencyBrowserExtensionContext } from 'Workspace/BrowserExtension/Context';

export function useBrowserExtension() {
	return React.useContext(ResiliencyBrowserExtensionContext);
}
